<template>
  <div class="QRCode" :style="styleObject">
    <img :src="srcBase64">
    <p></p>
  </div>
</template>

<script>
  import QRCode from 'qrcode'
  export default {
    props: {
      text: String,
      size: Number
    },
    data () {
      return {
        srcBase64: '',
        styleObject: {
          width: this.size + 'px',
          height: this.size + 'px'
        }
      }
    },
    methods: {
      getQRCode () {
        let opts = {
          errorCorrectionLevel: 'H',
          type: 'image/png',
          scale: 6
        }
        QRCode.toDataURL(this.text, opts, (err, url) => {
          if (err) throw err
          this.srcBase64 = url
        })
      }
    },
    created () {
      this.getQRCode()
    },
    watch: {
      'text' () {
        this.getQRCode()
      }
    }
  }
</script>

<style lang="less" scoped>
  .QRCode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      position: absolute;
      width: 24%;
      height: 24%;
      margin: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: url('/static/qrcodeICON.png') no-repeat center / cover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/QRCode/index.vue